<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #3b82f6;
  --primary-dark: #2563eb;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --danger-color: #ef4444;
  --info-color: #8b5cf6;
  --gray-bg: #f8fafc;
  --card-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  --card-hover-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
  --transition: all 0.25s cubic-bezier(0.2, 0.9, 0.4, 1.1);
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--gray-bg);
  color: #1e293b;
}

#app {
  min-height: 100vh;
  background-color: var(--gray-bg);
}

/* 卡片样式 */
.el-card {
  border-radius: 20px !important;
  border: none !important;
  box-shadow: var(--card-shadow) !important;
  transition: var(--transition);
  background-color: #ffffff;
  overflow: hidden;
}

.el-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--card-hover-shadow) !important;
}

.el-card__header {
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 20px;
  font-weight: 600;
  font-size: 16px;
  color: #1e2a3a;
  letter-spacing: 0.3px;
  border-radius: 20px 20px 0 0 !important;
}

/* 按钮 */
.el-button {
  border-radius: 40px;
  font-weight: 500;
  padding: 10px 20px;
  transition: var(--transition);
}

.el-button--primary {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  border: none;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.25);
}

.el-button--primary:hover {
  background: linear-gradient(135deg, var(--primary-dark), #1d4ed8);
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(59, 130, 246, 0.35);
}

.el-button--success {
  background: linear-gradient(135deg, var(--success-color), #059669);
  border: none;
}

.el-button--warning {
  background: linear-gradient(135deg, var(--warning-color), #d97706);
  border: none;
}

.el-button--danger {
  background: linear-gradient(135deg, var(--danger-color), #dc2626);
  border: none;
}

.el-button--text {
  border-radius: 40px;
  padding: 5px 12px;
}

.el-button:active {
  transform: scale(0.97);
  transition: transform 0.05s;
}

/* 表格 */
.el-table {
  border-radius: 16px;
  overflow: hidden;
}

.el-table th {
  background-color: #f8fafc;
  color: #1e293b;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.el-table td {
  border-bottom: 1px solid #f1f5f9;
}

.el-table--striped .el-table__row--striped td {
  background-color: #fafcff;
}

.el-table .cell {
  line-height: 1.5;
}

.el-table__row:hover > td {
  background-color: #fef9e3 !important;
  transition: background 0.2s;
}

/* 输入框 */
.el-input__inner,
.el-textarea__inner {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 下拉菜单 */
.el-select-dropdown__item {
  border-radius: 8px;
}

.el-select-dropdown__item.selected {
  background-color: #eff6ff;
  color: var(--primary-color);
  font-weight: 500;
}

/* 分页按钮 */
.page-button {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #1e293b;
  border-radius: 30px;
  padding: 6px 16px;
  transition: var(--transition);
  cursor: pointer;
}

.page-button:hover:not(:disabled) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.page-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 标签 */
.el-tag {
  border-radius: 30px;
  border: none;
  font-weight: 500;
  padding: 0 12px;
  height: 26px;
  line-height: 26px;
}

.el-tag--primary {
  background-color: #eff6ff;
  color: var(--primary-color);
}

.el-tag--success {
  background-color: #e0f2e9;
  color: #059669;
}

.el-tag--danger {
  background-color: #fee2e2;
  color: #dc2626;
}

.el-tag--info {
  background-color: #f1f5f9;
  color: #475569;
}

/* 弹窗 */
.el-dialog {
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.el-dialog__header {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  color: white;
  padding: 16px 24px;
  margin: 0;
}

.el-dialog__title {
  color: white;
  font-weight: 600;
}

.el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.el-dialog__body {
  padding: 24px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .el-button {
    border-radius: 30px;
    padding: 8px 16px;
  }

  .el-card {
    border-radius: 16px !important;
  }

  .el-card__header {
    padding: 12px 16px;
    font-size: 14px;
  }

  .el-table th,
  .el-table td {
    padding: 8px 4px !important;
  }

  /* 触摸反馈 */
  .el-button:active,
  .el-dropdown-item:active,
  .el-tabs__item:active {
    opacity: 0.7;
    transform: scale(0.98);
    transition: all 0.05s;
  }

  .el-button,
  .el-dropdown-item,
  .el-tabs__item {
    -webkit-tap-highlight-color: transparent;
    user-select: none;
  }

  /* 平滑滚动 */
  .el-table__body-wrapper,
  .el-dialog__body,
  .el-card__body {
    -webkit-overflow-scrolling: touch;
  }
}
</style>